import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { fDateTimeWithTimezone } from "../../../../../utils/formatTime";

InvoiceDeletion.propTypes = {
  logItem: PropTypes.object,
}

export default function InvoiceDeletion({ logItem }) {
  return <Box>
    <Typography variant="body" color="info.main" sx={{wordBreak: 'break-word', whiteSpace: 'normal'}}>
      Invoice #{logItem.invoiceNumber} deleted {logItem.deletedBy ? `by ${logItem.deletedBy}` : ''}
    </Typography>
    <Typography variant="body2" color="black">
      {fDateTimeWithTimezone(logItem.dateAdded)}
    </Typography>
  </Box>
}